/* src/app/features/distribuicao-limites-agentes/distribuicao-agentes/distribuicao-agentes.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=distribuicao-agentes.component.css.map */
